import React from 'react';
import {ObjectPropertyDetails} from "../../../types/Object";
import {ShowMore} from "../../../common/show-more/ShowMore";

type LiteralPropertyViewProps = {
  property: ObjectPropertyDetails
  defaultLang?: string
}

export default class LangStringPropertyView extends React.Component<LiteralPropertyViewProps> {

  static canHandle(property: ObjectPropertyDetails): boolean {
    return property.type === "Literal";
  }

  render() {
    const property = this.props.property;
    const defaultLang = this.props.defaultLang;

    if (property.multi) {
      if (property.value.length < 2) {
        return buildLiteralText(property.value[0]);
      }

      const values = property.value;
      if (defaultLang) {
        bumpDefaultLang(values, defaultLang);
      }

      const literals = values.map((val: any, index: number) => {
        return <li key={index}>{buildLiteralText(val)} </li>;
      });
      return <ul><ShowMore elements={literals} minSize={1}/></ul>;
    }
    return buildLiteralText(property.value);
  }
}

// TODO: This could go in the response mapper
function bumpDefaultLang(values: Array<any>, defaultLang: string) {
  const index = values.findIndex((literal: any) => {
    return literal.lang === defaultLang;
  });

  if (index > -1) {
    values.unshift(values.splice(index, 1)[0]);
  }
}

function buildLiteralText(literal: { lang: string, value: string }) {
  return <>{literal.value} <sup>{literal.lang}</sup></>;
}
